import styled from 'styled-components';
export const ContentCardWrapper = styled.div `
  position: absolute;
  position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    transform: translate(-50%, -50%);
}
`;
